<script>
  import QuestionFrame from './QuestionFrame.svelte';
</script>

<QuestionFrame>
  <p>Strahlen die Schmerzen aus?</p>
  <p>
    Zum Beispiel in Penis, Hoden, Vulva, Oberschenkelinnenseite, Gesäß, unterer Rücken, unterer
    Bauch, …
  </p>
  <p class="italic">
    Hinweis: Meistens strahlen die Schmerzen nur in einzelne Regionen aus, nicht in alle.
  </p>
</QuestionFrame>
